import { PlanogramPegboard } from "@CommonTypes/merchflow/pog/pegboard";
import { PlanogramShelf } from "@CommonTypes/merchflow/pog/shelf";
import { uuid } from "@CommonUtils/uuid";

export const createSyntheticHangcellPegboard = (shelf: PlanogramShelf) =>
  new PlanogramPegboard(
    {
      uniqueId: uuid(),
      placements: [],
      yBottom: shelf.getYBottom() - shelf.getHeight(),
      height: shelf.getHeight(),
      holesOffsetHorizontal: shelf.thickness * 2,
      holesOffsetVertical: shelf.thickness * 2,
      holesGapHorizontal: shelf.bay.width / 10,
      holesGapVertical: shelf.bay.width / 10,
    },
    shelf.bay,
  );
